import React, { memo } from 'react';
import type { FunctionComponent, ReactNode } from 'react';
import './DataBlock.scss';

interface DataBlockHeaderProps {
	children?: ReactNode;
}

export const DataBlockHeader: FunctionComponent<DataBlockHeaderProps> = memo(({ children }) => (
	<header className="data-block__row">
		<div className="data-block__item">
			<h2>{children}</h2>
		</div>
	</header>
));
